import { styled } from '@mui/material/styles';
import { Box, Paper } from '@mui/material';
import color from 'src/theme/color';

export const Wrapper = styled(Box)`
    position: relative;
    display: inline-flex;
`;

export const PopperPaper = styled(Paper)`
    background-color: ${color.darkGray};
    border: 1px solid ${color.white10};
    border-radius: 8px;
    overflow: hidden;
    min-width: 170px;
    margin-top: 4px;
`;

export const PopperOption = styled(Box)`
    padding: 10px 16px;
    font-family: Inter, sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: ${color.white90};
    cursor: pointer;
    transition: background-color 0.15s;

    &:hover {
        background-color: ${color.white10};
    }
`;
